import { useEffect, useState, useContext } from 'react';
import { useSnackbar } from 'notistack';
import { getConstructionsForSiteProcessCopy } from '../../../../apicalls/process';
import { TSelectItem } from '../../../../types/common';
import { checkResData } from '../../../../utils/common';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';
import { fetchConstructList } from '../../../../utils/processGantChartUtils';

export type TProps = {};

export const useHooks = (props: TProps) => {
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);
  // 工程コピーモーダルの表示制御
  const [isOpenCopy, setIsOpenCopy] = useState(false);
  // 工程追加モーダルの表示制御
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  // 工事選択リスト
  const [constructList, setConstructList] = useState<TSelectItem[]>([
    { value: 0, label: '--' }
  ]);

  // 「既存の工程表をコピー」クリック時のハンドラ
  const handleOnClickCopy = () => {
    setIsOpenCopy(true);
  };
  // 「工程表の追加」クリック時のハンドラ
  const handleOnClickAdd = () => {
    setIsOpenAdd(true);
  };

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  // 工程コピー用工事選択リスト設定（初回のみ）
  useEffect(() => {
    // 社外パートナー以外の場合
    if (authInfo?.role != ROLE['OUTSIDE_PARTNER']) {
      (async () => {
        const list = await fetchConstructList(enqueueSnackbar, true);
        setConstructList(list);
      })();
    }
  }, []);

  return {
    isOpenCopy,
    setIsOpenCopy,
    isOpenAdd,
    setIsOpenAdd,
    handleOnClickAdd,
    handleOnClickCopy,
    constructList
  };
};
